<script setup lang="ts" generic="MM">
import useVuelidate from '@vuelidate/core'
import { useI18n } from 'vue-i18n'
import TextField from '@/components/input/TextField.vue'
import { helpers, required } from '@vuelidate/validators'
import { computed, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { OrganizationSlugDataQuery, OrganizationSlugDataQueryVariables } from '@/generated/graphql'
import gql from 'graphql-tag'

const props = defineProps<{
  currentOrgId?: string
}>()
const model = defineModel<string>({})

const { t } = useI18n()

const fetchQuery = useQuery<OrganizationSlugDataQuery, OrganizationSlugDataQueryVariables>(
  gql`
    query OrganizationSlugData($slug: String!, $orgId: ID) {
      account {
        isOrganizationSlugTaken(slug: $slug, exceptOrganization: $orgId)
      }
    }
  `,
  () => ({
    slug: model.value as string,
    orgId: props.currentOrgId,
  }),
  () => ({
    enabled: (model.value?.length || 0) > 2,
    debounce: 500,
  }),
)
const isTaken = computed<boolean>(
  () => fetchQuery.result.value?.account.isOrganizationSlugTaken || false,
)

const validation = useVuelidate<ModelRef<string | undefined>>(
  {
    required,
    pattern: helpers.withMessage(
      t('validation.orgSlug.pattern'),
      helpers.regex(/^[a-z0-9-]{3,50}$/),
    ),
    taken: helpers.withMessage(t('validation.orgSlug.taken'), () => !isTaken.value),
  },
  model,
)
</script>

<template>
  <text-field v-model="model" :validation="validation">
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </text-field>
</template>

<style scoped lang="scss"></style>
